import { useParams } from 'react-router-dom';
import { CustomPagePage } from '../../../../../components/editor/CustomPage';

export default function CustomPage() {
	const { shortid } = useParams() as { shortid: string };

	return <CustomPagePage key={shortid} />;
}
